import { hide, show, removeClass, addClass } from "./common";
import HttpClient from "./http-client";

enum ToggleState {
    expanded,
    collapsed
}

interface ICategoryItem {
    PageId: number;
    Url: string;
    PageName: string;
    HasChildren: boolean;
}

export default class CategoryMenu {
    private baseElement: HTMLElement;
    private languageId: number;

    private toggleAttribute = 'data-toggle-state';
    private pageIdAttribute = 'data-page-id';
    private languageIdAttribute = 'data-language-id';
    private toggleButtonClass = 'cat-tree-list-expand-collapse-button';
    private expandedClass = 'expanded';

    constructor(element: HTMLElement) {
        this.baseElement = element;
    }

    public init(): void {
        this.languageId = Number(this.baseElement.getAttribute(this.languageIdAttribute));
        this.addToggleButtonClickHandler();
    }

    private addToggleButtonClickHandler() {
        document.body.addEventListener('click', async (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (target && target.classList.contains(this.toggleButtonClass)) {
                await this.toggleCategoryButtonAsync(target);
            }
        });
    }

    private async toggleCategoryButtonAsync(buttonElement: HTMLElement): Promise<void> {
        
        if (this.isButtonExpanded(buttonElement)){
            this.collapse(buttonElement);
            return;
        }

        const categoryElement = buttonElement.parentElement;

        if (categoryElement.querySelector('ul')) {
            this.expand(buttonElement);
            return;
        }

        await this.loadSubcategoriesAsync(categoryElement);
        this.expand(buttonElement);
    }
    private async loadSubcategoriesAsync(categoryElement: HTMLElement): Promise<void> {
        const pageId = Number(categoryElement.getAttribute(this.pageIdAttribute));
        const categories = await this.fetchCategoriesAsync(pageId);
        this.renderSubcategories(categoryElement, categories);
    }

    private renderSubcategories(categoryElement: HTMLElement, categories: ICategoryItem[]) {
        const ul = document.createElement('ul');
        categories.forEach(category => ul.appendChild(this.renderCategory(category)));
        categoryElement.appendChild(ul);
    }

    private renderCategory(category: ICategoryItem): HTMLLIElement {

        const li = document.createElement('li');
        li.setAttribute(this.pageIdAttribute, category.PageId.toString());

        const a = document.createElement('a');
        a.setAttribute('href', category.Url);
        a.innerHTML = category.PageName;

        li.appendChild(a);

        if (category.HasChildren) {
            const button = document.createElement('button');
            button.classList.add(this.toggleButtonClass);
            button.innerHTML = '+';
            button.setAttribute(this.toggleAttribute, ToggleState.collapsed.toString());
            li.appendChild(button);
        }

        return li;
    }

    private async fetchCategoriesAsync(pageId: number): Promise<ICategoryItem[]> {
        const apiUrl = this.getApiUrl(pageId);
        const response = await new HttpClient().fetch(apiUrl);
        const json = await response.json();
        return JSON.parse(json) as ICategoryItem[];
    }

    private collapse(buttonElement: HTMLElement) {
        const category = buttonElement.parentElement;
        const ul = category.querySelector('ul');
        hide(ul);
        buttonElement.setAttribute(this.toggleAttribute, ToggleState.collapsed.toString());
        removeClass(category, this.expandedClass);
        buttonElement.innerText = '+';
    }

    private expand(buttonElement: HTMLElement) {
        const category = buttonElement.parentElement;
        const ul = category.querySelector('ul');
        show(ul);
        buttonElement.setAttribute(this.toggleAttribute, ToggleState.expanded.toString());
        addClass(category, this.expandedClass);
        buttonElement.innerText = '-';
    }

    private isButtonExpanded(buttonElement: HTMLElement): boolean {
        return buttonElement.getAttribute(this.toggleAttribute) === ToggleState.expanded.toString();
    }

    private getApiUrl(pageId: number) {
        return `/CategoryMenu/${pageId}/${this.languageId}`;
    }

}

